export enum EOrientation
{
    Vertical = 0,
    Horizontal = 1
}


export class OrientationExtension {
    static opposite(orientation: EOrientation): EOrientation {
        return orientation === EOrientation.Horizontal ? EOrientation.Vertical : EOrientation.Horizontal;
    }
}
